import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SitePermissions } from 'src/app/shared/enums/permissions';
import { UserTableService } from '../core/database/user-table.service';
import { HsEventsComponent } from './hs-events/hs-events.component';
import { HsHomepageService } from './hs-homepage.service';
import { HsEmployerEventOptions } from 'src/app/shared/interfaces/employer-event';

@Component({
  selector: 'app-bd-homepage',
  templateUrl: './hs-homepage.component.html',
  styleUrls: ['./hs-homepage.component.scss'],
})
export class HsHomepageComponent implements OnInit {
  @ViewChild(HsEventsComponent) hsEventsComponent!: HsEventsComponent;

  constructor(
    private readonly userTableService: UserTableService,
    private readonly router: Router,
    private readonly hsHomepageService: HsHomepageService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  eventPermissions: { canEditEvent: boolean; canDeleteEvent: boolean } = {
    canEditEvent: false,
    canDeleteEvent: false,
  };

  loadingFilterOptions = false;
  filterError = false;
  filterOptions: HsEmployerEventOptions = {
    types: [],
    dateFrom: null,
    subcontractors: [],
    assessors: [],
  };

  selectedDateFrom: Date | null = null;
  selectedSubcontractorId: number | null = null;
  selectedAssessorId: number | null = null;

  availableTabs: string[] = [];
  activeTab = '';

  private staffId: number | null = null;

  ngOnInit(): void {
    this.userTableService.get(1).then((user) => {
      if (!user || user == undefined || user == null) {
        this.router.navigate(['/']);
        return;
      }

      if (!user.permission.includes(SitePermissions.HsHomepageView)) {
        this.router.navigate(['/']);
        return;
      }

      this.eventPermissions.canEditEvent = user.permission.includes(SitePermissions.EmployerEventEdit);
      this.eventPermissions.canDeleteEvent = user.permission.includes(SitePermissions.EmployerEventDelete);

      this.staffId = user.staffId;
      const staffId = this.staffId;

      const initialiseEventsComponent = () => {
        if (!this.hsEventsComponent) {
          return;
        }

        this.hsEventsComponent.setUp(staffId, this.eventPermissions);
        this.availableTabs = [...this.hsEventsComponent.tabs];
        this.activeTab = this.hsEventsComponent.activeTab;
      };

      if (this.hsEventsComponent) {
        initialiseEventsComponent();
      } else {
        Promise.resolve().then(initialiseEventsComponent);
      }

      this.loadFilterOptions();
    });
  }

  onDateFromChange(event: any): void {
    if (this.filterError) {
      return;
    }

    this.selectedDateFrom = event.value;
    this.applyFilters();
  }

  clearDateFrom(): void {
    if (this.loadingFilterOptions || this.filterError) {
      return;
    }

    this.selectedDateFrom = null;
    this.applyFilters();
  }

  clearFilters(): void {
    if (this.loadingFilterOptions || this.filterError) {
      return;
    }

    this.selectedDateFrom = this.filterOptions.dateFrom ? new Date(this.filterOptions.dateFrom) : null;
    this.selectedSubcontractorId = null;
    this.selectedAssessorId = null;
    this.applyFilters(true);
  }

  selectTab(tab: string): void {
    if (!this.hsEventsComponent || this.activeTab === tab) {
      return;
    }

    this.hsEventsComponent.changeTab(tab);
  }

  onTabChanged(tab: string): void {
    this.activeTab = tab;

    if (!this.availableTabs.length && this.hsEventsComponent) {
      this.availableTabs = [...this.hsEventsComponent.tabs];
    }
  }

  onFilterDateChanged(date: Date): void {
    this.selectedDateFrom = date;
  }

  onSubcontractorChange(): void {
    if (this.filterError) {
      return;
    }

    this.applyFilters();
  }

  onAssessorChange(): void {
    if (this.filterError) {
      return;
    }

    this.applyFilters();
  }

  private applyFilters(resetPage = true): void {
    if (!this.hsEventsComponent) {
      return;
    }

    this.hsEventsComponent.applyFilters(
      [],
      this.selectedDateFrom,
      this.selectedSubcontractorId,
      this.selectedAssessorId,
      resetPage
    );
  }

  private loadFilterOptions(): void {
    this.loadingFilterOptions = true;
    this.filterError = false;

    this.hsHomepageService.getEventFilterOptions(this.staffId).subscribe({
      next: (options: HsEmployerEventOptions) => {
        this.filterOptions = options;
        this.selectedDateFrom = options.dateFrom ? new Date(options.dateFrom) : null;

        if (this.hsEventsComponent) {
          this.hsEventsComponent.setEventOptions(options);
          this.applyFilters(true);
        } else {
          Promise.resolve().then(() => {
            if (!this.hsEventsComponent) {
              return;
            }

            this.hsEventsComponent.setEventOptions(options);
            this.applyFilters(true);
          });
        }
      },
      error: (error) => {
        console.error(error);
        this.filterError = true;
        this.loadingFilterOptions = false;
        this.cdr.detectChanges();
      },
      complete: () => {
        this.loadingFilterOptions = false;
        this.cdr.detectChanges();
      },
    });
  }
}
